"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Infrastructure Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.94
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TowerMappingApi = exports.TowerMappingApiFactory = exports.TowerMappingApiFp = exports.TowerMappingApiAxiosParamCreator = exports.TowerDependencyApi = exports.TowerDependencyApiFactory = exports.TowerDependencyApiFp = exports.TowerDependencyApiAxiosParamCreator = exports.TowerCoverageApi = exports.TowerCoverageApiFactory = exports.TowerCoverageApiFp = exports.TowerCoverageApiAxiosParamCreator = exports.TowerApi = exports.TowerApiFactory = exports.TowerApiFp = exports.TowerApiAxiosParamCreator = exports.PaddockApi = exports.PaddockApiFactory = exports.PaddockApiFp = exports.PaddockApiAxiosParamCreator = exports.InfraProductGroupApi = exports.InfraProductGroupApiFactory = exports.InfraProductGroupApiFp = exports.InfraProductGroupApiAxiosParamCreator = exports.InfraProductApi = exports.InfraProductApiFactory = exports.InfraProductApiFp = exports.InfraProductApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FrequencyPlanApi = exports.FrequencyPlanApiFactory = exports.FrequencyPlanApiFp = exports.FrequencyPlanApiAxiosParamCreator = exports.FarmApi = exports.FarmApiFactory = exports.FarmApiFp = exports.FarmApiAxiosParamCreator = exports.InfraProductVendorEnum = exports.InfraProductTypeEnum = exports.IEventTypeEnum = exports.CoverageStudyEnvironmentEnum = exports.CoverageStudyEngineEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.CoverageStudyEngineEnum = {
    CPU: 'CPU',
    GPU: 'GPU'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CoverageStudyEnvironmentEnum = {
    STAGING_TOOLS: 'STAGING_TOOLS',
    TOOLS: 'TOOLS'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InfraProductTypeEnum = {
    GATEWAY: 'GATEWAY',
    BATTERY_CONTROLLER: 'BATTERY_CONTROLLER',
    BATTERY: 'BATTERY',
    LED_INDICATOR: 'LED_INDICATOR',
    ROUTER: 'ROUTER',
    TOWER_NODE: 'TOWER_NODE',
    WIFI_CASE: 'WIFI_CASE',
    MESH_CASE: 'MESH_CASE',
    WIFI_MAST: 'WIFI_MAST',
    MESH_MAST: 'MESH_MAST',
    SOLAR_SWITCH: 'SOLAR_SWITCH',
    UPS: 'UPS',
    P2_P_ACCESS_POINT: 'P2P_ACCESS_POINT',
    P2_P_STATION: 'P2P_STATION'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InfraProductVendorEnum = {
    HALTER: 'HALTER',
    MULTI_TECH: 'MULTI_TECH',
    RAK: 'RAK',
    TEKTELIC: 'TEKTELIC',
    TELTONIKA: 'TELTONIKA',
    UBIQUITI: 'UBIQUITI',
    CTECHI: 'CTECHI',
    EPEVER: 'EPEVER',
    MIKROTIK: 'MIKROTIK',
    VENDOR_UNSPECIFIED: 'VENDOR_UNSPECIFIED'
};
/**
 * FarmApi - axios parameter creator
 * @export
 */
var FarmApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFarmByID', 'id', id);
                    localVarPath = "/infrastructure/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFarmByID', 'id', id);
                    localVarPath = "/infrastructure/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateFarmByID', 'id', id);
                    localVarPath = "/infrastructure/farm/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateFarmRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmApiAxiosParamCreator = FarmApiAxiosParamCreator;
/**
 * FarmApi - functional programming interface
 * @export
 */
var FarmApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFarm(iCreateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFarmByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFarms(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFarmByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFarmByID(id, iUpdateFarmRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmApiFp = FarmApiFp;
/**
 * FarmApi - factory interface
 * @export
 */
var FarmApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmApiFp)(configuration);
    return {
        /**
         * Create farm.
         * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFarm: function (iCreateFarmRequestDTO, options) {
            return localVarFp.createFarm(iCreateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFarmByID: function (id, options) {
            return localVarFp.deleteFarmByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all farms.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFarms: function (options) {
            return localVarFp.getAllFarms(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFarmByID: function (id, options) {
            return localVarFp.getFarmByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update farm by ID.
         * @param {string} id Unique ID of farm.
         * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFarmByID: function (id, iUpdateFarmRequestDTO, options) {
            return localVarFp.updateFarmByID(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmApiFactory = FarmApiFactory;
/**
 * FarmApi - object-oriented interface
 * @export
 * @class FarmApi
 * @extends {BaseAPI}
 */
var FarmApi = /** @class */ (function (_super) {
    __extends(FarmApi, _super);
    function FarmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create farm.
     * @param {ICreateFarmRequestDTO} [iCreateFarmRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.createFarm = function (iCreateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).createFarm(iCreateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.deleteFarmByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).deleteFarmByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all farms.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getAllFarms = function (options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getAllFarms(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.getFarmByID = function (id, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).getFarmByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update farm by ID.
     * @param {string} id Unique ID of farm.
     * @param {IUpdateFarmRequestDTO} [iUpdateFarmRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmApi
     */
    FarmApi.prototype.updateFarmByID = function (id, iUpdateFarmRequestDTO, options) {
        var _this = this;
        return (0, exports.FarmApiFp)(this.configuration).updateFarmByID(id, iUpdateFarmRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmApi;
}(base_1.BaseAPI));
exports.FarmApi = FarmApi;
/**
 * FrequencyPlanApi - axios parameter creator
 * @export
 */
var FrequencyPlanApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFrequencyPlanByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteFrequencyPlanByID', 'id', id);
                    localVarPath = "/infrastructure/frequency-plan/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all frequency plans.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlans: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/frequency-plan";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all frequency plans by band ID.
         * @param {string} bandId Unique ID of band.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlansByBandID: function (bandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'bandId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllFrequencyPlansByBandID', 'bandId', bandId);
                    localVarPath = "/infrastructure/frequency-plan/band/{bandId}"
                        .replace("{".concat("bandId", "}"), encodeURIComponent(String(bandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequencyPlanByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getFrequencyPlanByID', 'id', id);
                    localVarPath = "/infrastructure/frequency-plan/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Put frequency plan.
         * @param {IFrequencyPlanDTO} [iFrequencyPlanDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFrequencyPlan: function (iFrequencyPlanDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/frequency-plan";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iFrequencyPlanDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FrequencyPlanApiAxiosParamCreator = FrequencyPlanApiAxiosParamCreator;
/**
 * FrequencyPlanApi - functional programming interface
 * @export
 */
var FrequencyPlanApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FrequencyPlanApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFrequencyPlanByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFrequencyPlanByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all frequency plans.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlans: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFrequencyPlans(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all frequency plans by band ID.
         * @param {string} bandId Unique ID of band.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlansByBandID: function (bandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFrequencyPlansByBandID(bandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequencyPlanByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFrequencyPlanByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Put frequency plan.
         * @param {IFrequencyPlanDTO} [iFrequencyPlanDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFrequencyPlan: function (iFrequencyPlanDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putFrequencyPlan(iFrequencyPlanDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FrequencyPlanApiFp = FrequencyPlanApiFp;
/**
 * FrequencyPlanApi - factory interface
 * @export
 */
var FrequencyPlanApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FrequencyPlanApiFp)(configuration);
    return {
        /**
         * Delete frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFrequencyPlanByID: function (id, options) {
            return localVarFp.deleteFrequencyPlanByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all frequency plans.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlans: function (options) {
            return localVarFp.getAllFrequencyPlans(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all frequency plans by band ID.
         * @param {string} bandId Unique ID of band.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFrequencyPlansByBandID: function (bandId, options) {
            return localVarFp.getAllFrequencyPlansByBandID(bandId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get frequency plan by ID.
         * @param {string} id Unique ID of frequency plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequencyPlanByID: function (id, options) {
            return localVarFp.getFrequencyPlanByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put frequency plan.
         * @param {IFrequencyPlanDTO} [iFrequencyPlanDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFrequencyPlan: function (iFrequencyPlanDTO, options) {
            return localVarFp.putFrequencyPlan(iFrequencyPlanDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FrequencyPlanApiFactory = FrequencyPlanApiFactory;
/**
 * FrequencyPlanApi - object-oriented interface
 * @export
 * @class FrequencyPlanApi
 * @extends {BaseAPI}
 */
var FrequencyPlanApi = /** @class */ (function (_super) {
    __extends(FrequencyPlanApi, _super);
    function FrequencyPlanApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete frequency plan by ID.
     * @param {string} id Unique ID of frequency plan.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrequencyPlanApi
     */
    FrequencyPlanApi.prototype.deleteFrequencyPlanByID = function (id, options) {
        var _this = this;
        return (0, exports.FrequencyPlanApiFp)(this.configuration).deleteFrequencyPlanByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all frequency plans.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrequencyPlanApi
     */
    FrequencyPlanApi.prototype.getAllFrequencyPlans = function (options) {
        var _this = this;
        return (0, exports.FrequencyPlanApiFp)(this.configuration).getAllFrequencyPlans(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all frequency plans by band ID.
     * @param {string} bandId Unique ID of band.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrequencyPlanApi
     */
    FrequencyPlanApi.prototype.getAllFrequencyPlansByBandID = function (bandId, options) {
        var _this = this;
        return (0, exports.FrequencyPlanApiFp)(this.configuration).getAllFrequencyPlansByBandID(bandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get frequency plan by ID.
     * @param {string} id Unique ID of frequency plan.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrequencyPlanApi
     */
    FrequencyPlanApi.prototype.getFrequencyPlanByID = function (id, options) {
        var _this = this;
        return (0, exports.FrequencyPlanApiFp)(this.configuration).getFrequencyPlanByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put frequency plan.
     * @param {IFrequencyPlanDTO} [iFrequencyPlanDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrequencyPlanApi
     */
    FrequencyPlanApi.prototype.putFrequencyPlan = function (iFrequencyPlanDTO, options) {
        var _this = this;
        return (0, exports.FrequencyPlanApiFp)(this.configuration).putFrequencyPlan(iFrequencyPlanDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FrequencyPlanApi;
}(base_1.BaseAPI));
exports.FrequencyPlanApi = FrequencyPlanApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * InfraProductApi - axios parameter creator
 * @export
 */
var InfraProductApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create infra product context.
         * @param {ICreateInfraProductContextRequestDTO} [iCreateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductContext: function (iCreateInfraProductContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/infra-product/context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateInfraProductContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all infra product contexts by group ID.
         * @param {string} groupId Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByGroupID: function (groupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'groupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllInfraProductContextsByGroupID', 'groupId', groupId);
                    localVarPath = "/infrastructure/infra-product/context/group/{groupId}"
                        .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all infra product contexts by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllInfraProductContextsByTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/infra-product/context/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getInfraProductContextByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get infra product last metric by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductLastMetricByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getInfraProductLastMetricByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product/last-metric/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductStatusByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getInfraProductStatusByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update all infra product contexts tower id by group id.
         * @param {string} groupId Unique ID of group.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllInfraProductContextTowerIDByGroupID: function (groupId, towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'groupId' is not null or undefined
                    (0, common_1.assertParamExists)('updateAllInfraProductContextTowerIDByGroupID', 'groupId', groupId);
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('updateAllInfraProductContextTowerIDByGroupID', 'towerId', towerId);
                    localVarPath = "/infrastructure/infra-product/context/group/{groupId}/tower/{towerId}"
                        .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)))
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductContextRequestDTO} [iUpdateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductContextByID: function (id, iUpdateInfraProductContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateInfraProductContextByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product/context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateInfraProductContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductStatusRequestDTO} [iUpdateInfraProductStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductStatusByID: function (id, iUpdateInfraProductStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateInfraProductStatusByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateInfraProductStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InfraProductApiAxiosParamCreator = InfraProductApiAxiosParamCreator;
/**
 * InfraProductApi - functional programming interface
 * @export
 */
var InfraProductApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InfraProductApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create infra product context.
         * @param {ICreateInfraProductContextRequestDTO} [iCreateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductContext: function (iCreateInfraProductContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInfraProductContext(iCreateInfraProductContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all infra product contexts by group ID.
         * @param {string} groupId Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByGroupID: function (groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllInfraProductContextsByGroupID(groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all infra product contexts by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllInfraProductContextsByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInfraProductContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get infra product last metric by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductLastMetricByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInfraProductLastMetricByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductStatusByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInfraProductStatusByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update all infra product contexts tower id by group id.
         * @param {string} groupId Unique ID of group.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllInfraProductContextTowerIDByGroupID: function (groupId, towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAllInfraProductContextTowerIDByGroupID(groupId, towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductContextRequestDTO} [iUpdateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductContextByID: function (id, iUpdateInfraProductContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateInfraProductContextByID(id, iUpdateInfraProductContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductStatusRequestDTO} [iUpdateInfraProductStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductStatusByID: function (id, iUpdateInfraProductStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateInfraProductStatusByID(id, iUpdateInfraProductStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InfraProductApiFp = InfraProductApiFp;
/**
 * InfraProductApi - factory interface
 * @export
 */
var InfraProductApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InfraProductApiFp)(configuration);
    return {
        /**
         * Create infra product context.
         * @param {ICreateInfraProductContextRequestDTO} [iCreateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductContext: function (iCreateInfraProductContextRequestDTO, options) {
            return localVarFp.createInfraProductContext(iCreateInfraProductContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all infra product contexts by group ID.
         * @param {string} groupId Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByGroupID: function (groupId, options) {
            return localVarFp.getAllInfraProductContextsByGroupID(groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all infra product contexts by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductContextsByTowerID: function (towerId, options) {
            return localVarFp.getAllInfraProductContextsByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductContextByID: function (id, options) {
            return localVarFp.getInfraProductContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get infra product last metric by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductLastMetricByID: function (id, options) {
            return localVarFp.getInfraProductLastMetricByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductStatusByID: function (id, options) {
            return localVarFp.getInfraProductStatusByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update all infra product contexts tower id by group id.
         * @param {string} groupId Unique ID of group.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllInfraProductContextTowerIDByGroupID: function (groupId, towerId, options) {
            return localVarFp.updateAllInfraProductContextTowerIDByGroupID(groupId, towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update infra product context by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductContextRequestDTO} [iUpdateInfraProductContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductContextByID: function (id, iUpdateInfraProductContextRequestDTO, options) {
            return localVarFp.updateInfraProductContextByID(id, iUpdateInfraProductContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update infra product status by ID.
         * @param {string} id Unique ID of infra product.
         * @param {IUpdateInfraProductStatusRequestDTO} [iUpdateInfraProductStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductStatusByID: function (id, iUpdateInfraProductStatusRequestDTO, options) {
            return localVarFp.updateInfraProductStatusByID(id, iUpdateInfraProductStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InfraProductApiFactory = InfraProductApiFactory;
/**
 * InfraProductApi - object-oriented interface
 * @export
 * @class InfraProductApi
 * @extends {BaseAPI}
 */
var InfraProductApi = /** @class */ (function (_super) {
    __extends(InfraProductApi, _super);
    function InfraProductApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create infra product context.
     * @param {ICreateInfraProductContextRequestDTO} [iCreateInfraProductContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.createInfraProductContext = function (iCreateInfraProductContextRequestDTO, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).createInfraProductContext(iCreateInfraProductContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all infra product contexts by group ID.
     * @param {string} groupId Unique ID of group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.getAllInfraProductContextsByGroupID = function (groupId, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).getAllInfraProductContextsByGroupID(groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all infra product contexts by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.getAllInfraProductContextsByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).getAllInfraProductContextsByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get infra product context by ID.
     * @param {string} id Unique ID of infra product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.getInfraProductContextByID = function (id, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).getInfraProductContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get infra product last metric by ID.
     * @param {string} id Unique ID of infra product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.getInfraProductLastMetricByID = function (id, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).getInfraProductLastMetricByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get infra product status by ID.
     * @param {string} id Unique ID of infra product.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.getInfraProductStatusByID = function (id, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).getInfraProductStatusByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update all infra product contexts tower id by group id.
     * @param {string} groupId Unique ID of group.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.updateAllInfraProductContextTowerIDByGroupID = function (groupId, towerId, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).updateAllInfraProductContextTowerIDByGroupID(groupId, towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update infra product context by ID.
     * @param {string} id Unique ID of infra product.
     * @param {IUpdateInfraProductContextRequestDTO} [iUpdateInfraProductContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.updateInfraProductContextByID = function (id, iUpdateInfraProductContextRequestDTO, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).updateInfraProductContextByID(id, iUpdateInfraProductContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update infra product status by ID.
     * @param {string} id Unique ID of infra product.
     * @param {IUpdateInfraProductStatusRequestDTO} [iUpdateInfraProductStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductApi
     */
    InfraProductApi.prototype.updateInfraProductStatusByID = function (id, iUpdateInfraProductStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.InfraProductApiFp)(this.configuration).updateInfraProductStatusByID(id, iUpdateInfraProductStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InfraProductApi;
}(base_1.BaseAPI));
exports.InfraProductApi = InfraProductApi;
/**
 * InfraProductGroupApi - axios parameter creator
 * @export
 */
var InfraProductGroupApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create infra product group status.
         * @param {ICreateInfraProductGroupStatusRequestDTO} [iCreateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductGroupStatus: function (iCreateInfraProductGroupStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/infra-product-group/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateInfraProductGroupStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all infra product group statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductGroupStatuses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/infra-product-group/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductGroupStatusByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getInfraProductGroupStatusByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product-group/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {IUpdateInfraProductGroupStatusRequestDTO} [iUpdateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductGroupStatusByID: function (id, iUpdateInfraProductGroupStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateInfraProductGroupStatusByID', 'id', id);
                    localVarPath = "/infrastructure/infra-product-group/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateInfraProductGroupStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InfraProductGroupApiAxiosParamCreator = InfraProductGroupApiAxiosParamCreator;
/**
 * InfraProductGroupApi - functional programming interface
 * @export
 */
var InfraProductGroupApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InfraProductGroupApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create infra product group status.
         * @param {ICreateInfraProductGroupStatusRequestDTO} [iCreateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductGroupStatus: function (iCreateInfraProductGroupStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInfraProductGroupStatus(iCreateInfraProductGroupStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all infra product group statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductGroupStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllInfraProductGroupStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductGroupStatusByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInfraProductGroupStatusByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {IUpdateInfraProductGroupStatusRequestDTO} [iUpdateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductGroupStatusByID: function (id, iUpdateInfraProductGroupStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateInfraProductGroupStatusByID(id, iUpdateInfraProductGroupStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InfraProductGroupApiFp = InfraProductGroupApiFp;
/**
 * InfraProductGroupApi - factory interface
 * @export
 */
var InfraProductGroupApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InfraProductGroupApiFp)(configuration);
    return {
        /**
         * Create infra product group status.
         * @param {ICreateInfraProductGroupStatusRequestDTO} [iCreateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInfraProductGroupStatus: function (iCreateInfraProductGroupStatusRequestDTO, options) {
            return localVarFp.createInfraProductGroupStatus(iCreateInfraProductGroupStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all infra product group statuses.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInfraProductGroupStatuses: function (options) {
            return localVarFp.getAllInfraProductGroupStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfraProductGroupStatusByID: function (id, options) {
            return localVarFp.getInfraProductGroupStatusByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update infra product group status by ID.
         * @param {string} id Unique ID of group.
         * @param {IUpdateInfraProductGroupStatusRequestDTO} [iUpdateInfraProductGroupStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInfraProductGroupStatusByID: function (id, iUpdateInfraProductGroupStatusRequestDTO, options) {
            return localVarFp.updateInfraProductGroupStatusByID(id, iUpdateInfraProductGroupStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InfraProductGroupApiFactory = InfraProductGroupApiFactory;
/**
 * InfraProductGroupApi - object-oriented interface
 * @export
 * @class InfraProductGroupApi
 * @extends {BaseAPI}
 */
var InfraProductGroupApi = /** @class */ (function (_super) {
    __extends(InfraProductGroupApi, _super);
    function InfraProductGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create infra product group status.
     * @param {ICreateInfraProductGroupStatusRequestDTO} [iCreateInfraProductGroupStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductGroupApi
     */
    InfraProductGroupApi.prototype.createInfraProductGroupStatus = function (iCreateInfraProductGroupStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.InfraProductGroupApiFp)(this.configuration).createInfraProductGroupStatus(iCreateInfraProductGroupStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all infra product group statuses.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductGroupApi
     */
    InfraProductGroupApi.prototype.getAllInfraProductGroupStatuses = function (options) {
        var _this = this;
        return (0, exports.InfraProductGroupApiFp)(this.configuration).getAllInfraProductGroupStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get infra product group status by ID.
     * @param {string} id Unique ID of group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductGroupApi
     */
    InfraProductGroupApi.prototype.getInfraProductGroupStatusByID = function (id, options) {
        var _this = this;
        return (0, exports.InfraProductGroupApiFp)(this.configuration).getInfraProductGroupStatusByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update infra product group status by ID.
     * @param {string} id Unique ID of group.
     * @param {IUpdateInfraProductGroupStatusRequestDTO} [iUpdateInfraProductGroupStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfraProductGroupApi
     */
    InfraProductGroupApi.prototype.updateInfraProductGroupStatusByID = function (id, iUpdateInfraProductGroupStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.InfraProductGroupApiFp)(this.configuration).updateInfraProductGroupStatusByID(id, iUpdateInfraProductGroupStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InfraProductGroupApi;
}(base_1.BaseAPI));
exports.InfraProductGroupApi = InfraProductGroupApi;
/**
 * PaddockApi - axios parameter creator
 * @export
 */
var PaddockApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create paddock status.
         * @param {ICreatePaddockStatusRequestDTO} [iCreatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockStatus: function (iCreatePaddockStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/paddock/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreatePaddockStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create paddock tower dependency.
         * @param {ICreatePaddockTowerDependencyRequestDTO} [iCreatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockTowerDependency: function (iCreatePaddockTowerDependencyRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/paddock/dependency";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreatePaddockTowerDependencyRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockStatusByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deletePaddockStatusByID', 'id', id);
                    localVarPath = "/infrastructure/paddock/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('deletePaddockTowerDependencyByPaddockIDAndTowerID', 'towerId', towerId);
                    // verify required parameter 'paddockId' is not null or undefined
                    (0, common_1.assertParamExists)('deletePaddockTowerDependencyByPaddockIDAndTowerID', 'paddockId', paddockId);
                    localVarPath = "/infrastructure/paddock/dependency/{paddockId}/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)))
                        .replace("{".concat("paddockId", "}"), encodeURIComponent(String(paddockId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all paddock statuses by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockStatusesByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllPaddockStatusesByFarmID', 'farmId', farmId);
                    localVarPath = "/infrastructure/paddock/status/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all paddock tower dependencies by paddock ID.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByPaddockID: function (paddockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'paddockId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllPaddockTowerDependenciesByPaddockID', 'paddockId', paddockId);
                    localVarPath = "/infrastructure/paddock/dependency/paddock/{paddockId}"
                        .replace("{".concat("paddockId", "}"), encodeURIComponent(String(paddockId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all paddock tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllPaddockTowerDependenciesByTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/paddock/dependency/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaddockStatusByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getPaddockStatusByID', 'id', id);
                    localVarPath = "/infrastructure/paddock/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {IUpdatePaddockStatusRequestDTO} [iUpdatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockStatusByID: function (id, iUpdatePaddockStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updatePaddockStatusByID', 'id', id);
                    localVarPath = "/infrastructure/paddock/status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdatePaddockStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {IUpdatePaddockTowerDependencyRequestDTO} [iUpdatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('updatePaddockTowerDependencyByPaddockIDAndTowerID', 'towerId', towerId);
                    // verify required parameter 'paddockId' is not null or undefined
                    (0, common_1.assertParamExists)('updatePaddockTowerDependencyByPaddockIDAndTowerID', 'paddockId', paddockId);
                    localVarPath = "/infrastructure/paddock/dependency/{paddockId}/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)))
                        .replace("{".concat("paddockId", "}"), encodeURIComponent(String(paddockId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdatePaddockTowerDependencyRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PaddockApiAxiosParamCreator = PaddockApiAxiosParamCreator;
/**
 * PaddockApi - functional programming interface
 * @export
 */
var PaddockApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PaddockApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create paddock status.
         * @param {ICreatePaddockStatusRequestDTO} [iCreatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockStatus: function (iCreatePaddockStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPaddockStatus(iCreatePaddockStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create paddock tower dependency.
         * @param {ICreatePaddockTowerDependencyRequestDTO} [iCreatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockTowerDependency: function (iCreatePaddockTowerDependencyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPaddockTowerDependency(iCreatePaddockTowerDependencyRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockStatusByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePaddockStatusByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all paddock statuses by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockStatusesByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllPaddockStatusesByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all paddock tower dependencies by paddock ID.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByPaddockID: function (paddockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllPaddockTowerDependenciesByPaddockID(paddockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all paddock tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllPaddockTowerDependenciesByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaddockStatusByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaddockStatusByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {IUpdatePaddockStatusRequestDTO} [iUpdatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockStatusByID: function (id, iUpdatePaddockStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePaddockStatusByID(id, iUpdatePaddockStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {IUpdatePaddockTowerDependencyRequestDTO} [iUpdatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PaddockApiFp = PaddockApiFp;
/**
 * PaddockApi - factory interface
 * @export
 */
var PaddockApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PaddockApiFp)(configuration);
    return {
        /**
         * Create paddock status.
         * @param {ICreatePaddockStatusRequestDTO} [iCreatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockStatus: function (iCreatePaddockStatusRequestDTO, options) {
            return localVarFp.createPaddockStatus(iCreatePaddockStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create paddock tower dependency.
         * @param {ICreatePaddockTowerDependencyRequestDTO} [iCreatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaddockTowerDependency: function (iCreatePaddockTowerDependencyRequestDTO, options) {
            return localVarFp.createPaddockTowerDependency(iCreatePaddockTowerDependencyRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockStatusByID: function (id, options) {
            return localVarFp.deletePaddockStatusByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, options) {
            return localVarFp.deletePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all paddock statuses by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockStatusesByFarmID: function (farmId, options) {
            return localVarFp.getAllPaddockStatusesByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all paddock tower dependencies by paddock ID.
         * @param {string} paddockId Unique ID of paddock.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByPaddockID: function (paddockId, options) {
            return localVarFp.getAllPaddockTowerDependenciesByPaddockID(paddockId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all paddock tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPaddockTowerDependenciesByTowerID: function (towerId, options) {
            return localVarFp.getAllPaddockTowerDependenciesByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaddockStatusByID: function (id, options) {
            return localVarFp.getPaddockStatusByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update paddock status by ID.
         * @param {string} id Unique ID of paddock status.
         * @param {IUpdatePaddockStatusRequestDTO} [iUpdatePaddockStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockStatusByID: function (id, iUpdatePaddockStatusRequestDTO, options) {
            return localVarFp.updatePaddockStatusByID(id, iUpdatePaddockStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update paddock tower dependency by paddock ID and tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {string} paddockId Unique ID of paddock.
         * @param {IUpdatePaddockTowerDependencyRequestDTO} [iUpdatePaddockTowerDependencyRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaddockTowerDependencyByPaddockIDAndTowerID: function (towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options) {
            return localVarFp.updatePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PaddockApiFactory = PaddockApiFactory;
/**
 * PaddockApi - object-oriented interface
 * @export
 * @class PaddockApi
 * @extends {BaseAPI}
 */
var PaddockApi = /** @class */ (function (_super) {
    __extends(PaddockApi, _super);
    function PaddockApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create paddock status.
     * @param {ICreatePaddockStatusRequestDTO} [iCreatePaddockStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.createPaddockStatus = function (iCreatePaddockStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).createPaddockStatus(iCreatePaddockStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create paddock tower dependency.
     * @param {ICreatePaddockTowerDependencyRequestDTO} [iCreatePaddockTowerDependencyRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.createPaddockTowerDependency = function (iCreatePaddockTowerDependencyRequestDTO, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).createPaddockTowerDependency(iCreatePaddockTowerDependencyRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete paddock status by ID.
     * @param {string} id Unique ID of paddock status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.deletePaddockStatusByID = function (id, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).deletePaddockStatusByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete paddock tower dependency by paddock ID and tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {string} paddockId Unique ID of paddock.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.deletePaddockTowerDependencyByPaddockIDAndTowerID = function (towerId, paddockId, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).deletePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all paddock statuses by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.getAllPaddockStatusesByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).getAllPaddockStatusesByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all paddock tower dependencies by paddock ID.
     * @param {string} paddockId Unique ID of paddock.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.getAllPaddockTowerDependenciesByPaddockID = function (paddockId, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).getAllPaddockTowerDependenciesByPaddockID(paddockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all paddock tower dependency by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.getAllPaddockTowerDependenciesByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).getAllPaddockTowerDependenciesByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get paddock status by ID.
     * @param {string} id Unique ID of paddock status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.getPaddockStatusByID = function (id, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).getPaddockStatusByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update paddock status by ID.
     * @param {string} id Unique ID of paddock status.
     * @param {IUpdatePaddockStatusRequestDTO} [iUpdatePaddockStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.updatePaddockStatusByID = function (id, iUpdatePaddockStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).updatePaddockStatusByID(id, iUpdatePaddockStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update paddock tower dependency by paddock ID and tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {string} paddockId Unique ID of paddock.
     * @param {IUpdatePaddockTowerDependencyRequestDTO} [iUpdatePaddockTowerDependencyRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaddockApi
     */
    PaddockApi.prototype.updatePaddockTowerDependencyByPaddockIDAndTowerID = function (towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options) {
        var _this = this;
        return (0, exports.PaddockApiFp)(this.configuration).updatePaddockTowerDependencyByPaddockIDAndTowerID(towerId, paddockId, iUpdatePaddockTowerDependencyRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PaddockApi;
}(base_1.BaseAPI));
exports.PaddockApi = PaddockApi;
/**
 * TowerApi - axios parameter creator
 * @export
 */
var TowerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerByID', 'id', id);
                    localVarPath = "/infrastructure/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all tower metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByFarmID', 'farmId', farmId);
                    localVarPath = "/infrastructure/tower/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers from the specified latitude longitude coordinates within the specified radius.
         * @param {number} latitude Latitude of location.
         * @param {number} longitude Longitude of location.
         * @param {number} radius Radius of location in metres.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByLatLngAndRadius: function (latitude, longitude, radius, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'latitude' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByLatLngAndRadius', 'latitude', latitude);
                    // verify required parameter 'longitude' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByLatLngAndRadius', 'longitude', longitude);
                    // verify required parameter 'radius' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByLatLngAndRadius', 'radius', radius);
                    localVarPath = "/infrastructure/tower/location";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (latitude !== undefined) {
                        localVarQueryParameter['latitude'] = latitude;
                    }
                    if (longitude !== undefined) {
                        localVarQueryParameter['longitude'] = longitude;
                    }
                    if (radius !== undefined) {
                        localVarQueryParameter['radius'] = radius;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerByID', 'id', id);
                    localVarPath = "/infrastructure/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower metadata by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerMetadataByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerMetadataByID', 'id', id);
                    localVarPath = "/infrastructure/tower/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateTowerByID', 'id', id);
                    localVarPath = "/infrastructure/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTowerRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update tower metadata.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerMetadataRequestDTO} [iUpdateTowerMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerMetadataByID: function (id, iUpdateTowerMetadataRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateTowerMetadataByID', 'id', id);
                    localVarPath = "/infrastructure/tower/metadata/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTowerMetadataRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TowerApiAxiosParamCreator = TowerApiAxiosParamCreator;
/**
 * TowerApi - functional programming interface
 * @export
 */
var TowerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TowerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTower(iCreateTowerRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all tower metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowerMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowersByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers from the specified latitude longitude coordinates within the specified radius.
         * @param {number} latitude Latitude of location.
         * @param {number} longitude Longitude of location.
         * @param {number} radius Radius of location in metres.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByLatLngAndRadius: function (latitude, longitude, radius, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowersByLatLngAndRadius(latitude, longitude, radius, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower metadata by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerMetadataByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerMetadataByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTowerByID(id, iUpdateTowerRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update tower metadata.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerMetadataRequestDTO} [iUpdateTowerMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerMetadataByID: function (id, iUpdateTowerMetadataRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTowerMetadataByID(id, iUpdateTowerMetadataRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TowerApiFp = TowerApiFp;
/**
 * TowerApi - factory interface
 * @export
 */
var TowerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TowerApiFp)(configuration);
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            return localVarFp.createTower(iCreateTowerRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            return localVarFp.deleteTowerByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all tower metadata.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerMetadata: function (options) {
            return localVarFp.getAllTowerMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            return localVarFp.getAllTowers(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            return localVarFp.getAllTowersByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers from the specified latitude longitude coordinates within the specified radius.
         * @param {number} latitude Latitude of location.
         * @param {number} longitude Longitude of location.
         * @param {number} radius Radius of location in metres.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByLatLngAndRadius: function (latitude, longitude, radius, options) {
            return localVarFp.getAllTowersByLatLngAndRadius(latitude, longitude, radius, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            return localVarFp.getTowerByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower metadata by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerMetadataByID: function (id, options) {
            return localVarFp.getTowerMetadataByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            return localVarFp.updateTowerByID(id, iUpdateTowerRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update tower metadata.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerMetadataRequestDTO} [iUpdateTowerMetadataRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerMetadataByID: function (id, iUpdateTowerMetadataRequestDTO, options) {
            return localVarFp.updateTowerMetadataByID(id, iUpdateTowerMetadataRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TowerApiFactory = TowerApiFactory;
/**
 * TowerApi - object-oriented interface
 * @export
 * @class TowerApi
 * @extends {BaseAPI}
 */
var TowerApi = /** @class */ (function (_super) {
    __extends(TowerApi, _super);
    function TowerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create tower.
     * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.createTower = function (iCreateTowerRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).createTower(iCreateTowerRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.deleteTowerByID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).deleteTowerByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all tower metadata.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowerMetadata = function (options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowerMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowers = function (options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowersByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowersByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers from the specified latitude longitude coordinates within the specified radius.
     * @param {number} latitude Latitude of location.
     * @param {number} longitude Longitude of location.
     * @param {number} radius Radius of location in metres.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowersByLatLngAndRadius = function (latitude, longitude, radius, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowersByLatLngAndRadius(latitude, longitude, radius, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getTowerByID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getTowerByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower metadata by ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getTowerMetadataByID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getTowerMetadataByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.updateTowerByID = function (id, iUpdateTowerRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).updateTowerByID(id, iUpdateTowerRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update tower metadata.
     * @param {string} id Unique ID of tower.
     * @param {IUpdateTowerMetadataRequestDTO} [iUpdateTowerMetadataRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.updateTowerMetadataByID = function (id, iUpdateTowerMetadataRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).updateTowerMetadataByID(id, iUpdateTowerMetadataRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TowerApi;
}(base_1.BaseAPI));
exports.TowerApi = TowerApi;
/**
 * TowerCoverageApi - axios parameter creator
 * @export
 */
var TowerCoverageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get tower coverage study by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyByID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerCoverageStudyByID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-coverage/study/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower coverage study image by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyImageByID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerCoverageStudyImageByID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-coverage/study/{towerId}/image.png"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Put tower coverage study.
         * @param {ITowerCoverageStudyDTO} [iTowerCoverageStudyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerCoverageStudy: function (iTowerCoverageStudyDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower-coverage/study";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iTowerCoverageStudyDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TowerCoverageApiAxiosParamCreator = TowerCoverageApiAxiosParamCreator;
/**
 * TowerCoverageApi - functional programming interface
 * @export
 */
var TowerCoverageApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TowerCoverageApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get tower coverage study by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyByID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerCoverageStudyByID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower coverage study image by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyImageByID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerCoverageStudyImageByID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Put tower coverage study.
         * @param {ITowerCoverageStudyDTO} [iTowerCoverageStudyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerCoverageStudy: function (iTowerCoverageStudyDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putTowerCoverageStudy(iTowerCoverageStudyDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TowerCoverageApiFp = TowerCoverageApiFp;
/**
 * TowerCoverageApi - factory interface
 * @export
 */
var TowerCoverageApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TowerCoverageApiFp)(configuration);
    return {
        /**
         * Get tower coverage study by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyByID: function (towerId, options) {
            return localVarFp.getTowerCoverageStudyByID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower coverage study image by ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerCoverageStudyImageByID: function (towerId, options) {
            return localVarFp.getTowerCoverageStudyImageByID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put tower coverage study.
         * @param {ITowerCoverageStudyDTO} [iTowerCoverageStudyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerCoverageStudy: function (iTowerCoverageStudyDTO, options) {
            return localVarFp.putTowerCoverageStudy(iTowerCoverageStudyDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TowerCoverageApiFactory = TowerCoverageApiFactory;
/**
 * TowerCoverageApi - object-oriented interface
 * @export
 * @class TowerCoverageApi
 * @extends {BaseAPI}
 */
var TowerCoverageApi = /** @class */ (function (_super) {
    __extends(TowerCoverageApi, _super);
    function TowerCoverageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get tower coverage study by ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerCoverageApi
     */
    TowerCoverageApi.prototype.getTowerCoverageStudyByID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerCoverageApiFp)(this.configuration).getTowerCoverageStudyByID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower coverage study image by ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerCoverageApi
     */
    TowerCoverageApi.prototype.getTowerCoverageStudyImageByID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerCoverageApiFp)(this.configuration).getTowerCoverageStudyImageByID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put tower coverage study.
     * @param {ITowerCoverageStudyDTO} [iTowerCoverageStudyDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerCoverageApi
     */
    TowerCoverageApi.prototype.putTowerCoverageStudy = function (iTowerCoverageStudyDTO, options) {
        var _this = this;
        return (0, exports.TowerCoverageApiFp)(this.configuration).putTowerCoverageStudy(iTowerCoverageStudyDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TowerCoverageApi;
}(base_1.BaseAPI));
exports.TowerCoverageApi = TowerCoverageApi;
/**
 * TowerDependencyApi - axios parameter creator
 * @export
 */
var TowerDependencyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerDependencyByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerDependencyByTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-dependency/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerDependencyByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerDependencyByTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-dependency/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Put tower dependency.
         * @param {ITowerDependencyDTO} [iTowerDependencyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerDependency: function (iTowerDependencyDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower-dependency/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iTowerDependencyDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TowerDependencyApiAxiosParamCreator = TowerDependencyApiAxiosParamCreator;
/**
 * TowerDependencyApi - functional programming interface
 * @export
 */
var TowerDependencyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TowerDependencyApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerDependencyByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerDependencyByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerDependencyByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerDependencyByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Put tower dependency.
         * @param {ITowerDependencyDTO} [iTowerDependencyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerDependency: function (iTowerDependencyDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putTowerDependency(iTowerDependencyDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TowerDependencyApiFp = TowerDependencyApiFp;
/**
 * TowerDependencyApi - factory interface
 * @export
 */
var TowerDependencyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TowerDependencyApiFp)(configuration);
    return {
        /**
         * Delete tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerDependencyByTowerID: function (towerId, options) {
            return localVarFp.deleteTowerDependencyByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower dependency by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerDependencyByTowerID: function (towerId, options) {
            return localVarFp.getTowerDependencyByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put tower dependency.
         * @param {ITowerDependencyDTO} [iTowerDependencyDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTowerDependency: function (iTowerDependencyDTO, options) {
            return localVarFp.putTowerDependency(iTowerDependencyDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TowerDependencyApiFactory = TowerDependencyApiFactory;
/**
 * TowerDependencyApi - object-oriented interface
 * @export
 * @class TowerDependencyApi
 * @extends {BaseAPI}
 */
var TowerDependencyApi = /** @class */ (function (_super) {
    __extends(TowerDependencyApi, _super);
    function TowerDependencyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete tower dependency by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerDependencyApi
     */
    TowerDependencyApi.prototype.deleteTowerDependencyByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerDependencyApiFp)(this.configuration).deleteTowerDependencyByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower dependency by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerDependencyApi
     */
    TowerDependencyApi.prototype.getTowerDependencyByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerDependencyApiFp)(this.configuration).getTowerDependencyByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put tower dependency.
     * @param {ITowerDependencyDTO} [iTowerDependencyDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerDependencyApi
     */
    TowerDependencyApi.prototype.putTowerDependency = function (iTowerDependencyDTO, options) {
        var _this = this;
        return (0, exports.TowerDependencyApiFp)(this.configuration).putTowerDependency(iTowerDependencyDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TowerDependencyApi;
}(base_1.BaseAPI));
exports.TowerDependencyApi = TowerDependencyApi;
/**
 * TowerMappingApi - axios parameter creator
 * @export
 */
var TowerMappingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingRequestDTO} [iCreateTowerFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/infrastructure/tower-mapping/farm";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerFarmMappingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete tower farm mapping by farm ID and tower ID.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerFarmMappingByFarmIDAndTowerID', 'farmId', farmId);
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerFarmMappingByFarmIDAndTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-mapping/farm/{farmId}/{towerId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)))
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all tower farm mappings by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowerFarmMappingsByFarmID', 'farmId', farmId);
                    localVarPath = "/infrastructure/tower-mapping/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowerFarmMappingsByTowerID', 'towerId', towerId);
                    localVarPath = "/infrastructure/tower-mapping/farm/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TowerMappingApiAxiosParamCreator = TowerMappingApiAxiosParamCreator;
/**
 * TowerMappingApi - functional programming interface
 * @export
 */
var TowerMappingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TowerMappingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingRequestDTO} [iCreateTowerFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTowerFarmMapping(iCreateTowerFarmMappingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tower farm mapping by farm ID and tower ID.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all tower farm mappings by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowerFarmMappingsByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowerFarmMappingsByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TowerMappingApiFp = TowerMappingApiFp;
/**
 * TowerMappingApi - factory interface
 * @export
 */
var TowerMappingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TowerMappingApiFp)(configuration);
    return {
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingRequestDTO} [iCreateTowerFarmMappingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingRequestDTO, options) {
            return localVarFp.createTowerFarmMapping(iCreateTowerFarmMappingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tower farm mapping by farm ID and tower ID.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            return localVarFp.deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all tower farm mappings by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByFarmID: function (farmId, options) {
            return localVarFp.getAllTowerFarmMappingsByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            return localVarFp.getAllTowerFarmMappingsByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TowerMappingApiFactory = TowerMappingApiFactory;
/**
 * TowerMappingApi - object-oriented interface
 * @export
 * @class TowerMappingApi
 * @extends {BaseAPI}
 */
var TowerMappingApi = /** @class */ (function (_super) {
    __extends(TowerMappingApi, _super);
    function TowerMappingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create tower farm mapping.
     * @param {ICreateTowerFarmMappingRequestDTO} [iCreateTowerFarmMappingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerMappingApi
     */
    TowerMappingApi.prototype.createTowerFarmMapping = function (iCreateTowerFarmMappingRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerMappingApiFp)(this.configuration).createTowerFarmMapping(iCreateTowerFarmMappingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tower farm mapping by farm ID and tower ID.
     * @param {string} farmId Unique ID of farm.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerMappingApi
     */
    TowerMappingApi.prototype.deleteTowerFarmMappingByFarmIDAndTowerID = function (farmId, towerId, options) {
        var _this = this;
        return (0, exports.TowerMappingApiFp)(this.configuration).deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all tower farm mappings by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerMappingApi
     */
    TowerMappingApi.prototype.getAllTowerFarmMappingsByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.TowerMappingApiFp)(this.configuration).getAllTowerFarmMappingsByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all tower farm mappings by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerMappingApi
     */
    TowerMappingApi.prototype.getAllTowerFarmMappingsByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerMappingApiFp)(this.configuration).getAllTowerFarmMappingsByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TowerMappingApi;
}(base_1.BaseAPI));
exports.TowerMappingApi = TowerMappingApi;
